import { createFileRoute, redirect } from '@tanstack/react-router'

import { requireManage } from '@/auth/require-manage'

export const Route = createFileRoute('/_layout/feedback-forms/new')({
  beforeLoad: ({ context }) => {
    requireManage(context.me, 'feedback-forms', redirect({ to: '/feedback-forms', replace: true }))
  },
})
